if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');


        const priceEl = this.submitButton.querySelector('.price--final');
        const compareEl = this.submitButton.querySelector('.price--compare');




        this.onVariantChange = this.onVariantChange.bind(this);
        this.addEventListener('variant:change', this.onVariantChange);

      }
      onVariantChange(event) {
        const variant = event.detail.variant;
        if (!variant) return;

        const priceEl = this.submitButton.querySelector('.price--final');
        const compareEl = this.submitButton.querySelector('.price--compare');

        if (!priceEl) return;

        priceEl.innerHTML = Shopify.formatMoney(variant.price);

        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.innerHTML = Shopify.formatMoney(variant.compare_at_price);
          compareEl.hidden = false;
        } else if (compareEl) {
          compareEl.hidden = true;
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');

          this.submitButtonText.innerHTML = `
            ADD TO CART —
            <span class="price price--compare" hidden></span>
            <span class="price price--final"></span>
               <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M3.6001 12C3.6001 11.7613 3.69492 11.5324 3.8637 11.3636C4.03248 11.1948 4.2614 11.1 4.5001 11.1H17.2657L12.2761 6.34798C12.1869 6.26706 12.1148 6.16905 12.0642 6.05977C12.0135 5.95048 11.9853 5.83214 11.9813 5.71176C11.9772 5.59138 11.9974 5.47141 12.0405 5.35896C12.0837 5.2465 12.1489 5.14386 12.2325 5.05709C12.316 4.97033 12.4161 4.90123 12.5269 4.85386C12.6376 4.8065 12.7568 4.78186 12.8772 4.78138C12.9977 4.7809 13.117 4.80461 13.2281 4.85109C13.3392 4.89757 13.4399 4.96589 13.5241 5.05198L20.1241 11.352C20.2112 11.4359 20.2805 11.5366 20.3278 11.6479C20.3751 11.7593 20.3995 11.879 20.3995 12C20.3995 12.121 20.3751 12.2407 20.3278 12.352C20.2805 12.4634 20.2112 12.564 20.1241 12.648L13.5241 18.948C13.4399 19.0341 13.3392 19.1024 13.2281 19.1489C13.117 19.1954 12.9977 19.2191 12.8772 19.2186C12.7568 19.2181 12.6376 19.1935 12.5269 19.1461C12.4161 19.0987 12.316 19.0296 12.2325 18.9429C12.1489 18.8561 12.0837 18.7535 12.0405 18.641C11.9974 18.5286 11.9772 18.4086 11.9813 18.2882C11.9853 18.1678 12.0135 18.0495 12.0642 17.9402C12.1148 17.8309 12.1869 17.7329 12.2761 17.652L17.2657 12.9H4.5001C4.2614 12.9 4.03248 12.8052 3.8637 12.6364C3.69492 12.4676 3.6001 12.2387 3.6001 12Z" fill="#E0BFA8" />
              </svg>
          `;
        }
      }


      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

const formatMoney = (cents) => {
  if (window.Shopify?.currency?.active) {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: window.Shopify.currency.active,
    }).format(cents / 100);
  }
  return `$${(cents / 100).toFixed(2)}`;
};

document.querySelectorAll('product-form').forEach((productForm) => {
  const variantInput = productForm.querySelector('input[name="id"]');
  if (!variantInput) return;
  let lastVariantId = variantInput.value;
  const updateButtonPrice = (variantId) => {

    fetch(`/variants/${variantId}.js`)
      .then((r) => r.json())
      .then((variant) => {
        const button = productForm.querySelector('.product-form__submit');
        const priceEl = button?.querySelector('.price--final');
        const compareEl = button?.querySelector('.price--compare');

        if (!priceEl) return;

        priceEl.innerHTML = formatMoney(variant.price);


        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.innerHTML = formatMoney(variant.compare_at_price);
          compareEl.hidden = false;
        } else if (compareEl) {
          compareEl.hidden = true;
        }
      });
  };

  updateButtonPrice(lastVariantId);

  new MutationObserver(() => {
    if (variantInput.value !== lastVariantId) {
      lastVariantId = variantInput.value;
      updateButtonPrice(lastVariantId);
    }
  }).observe(variantInput, { attributes: true, attributeFilter: ['value'] });
});


document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-cart-drawer-close]');
  if (!btn) return;

  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;

  drawer.close();
});

(() => {
  const updateCheckoutPrice = (cart) => {
    const btn = document.querySelector('#CartDrawer-Checkout');
    if (!btn || !cart) return;

    const priceEl = btn.querySelector('.cart-checkout-price');
    if (!priceEl) return;
    
    priceEl.textContent = `— ${formatMoney(cart.total_price)}`;      
   

  };

  subscribe(PUB_SUB_EVENTS.cartUpdate, ({ cartData }) => {
    updateCheckoutPrice(cartData);
  });

})();


(() => {
  const updateTotals = (cart) => {
    if (!cart) return;

    console.log('[CART TOTALS] update', cart);

    const subtotalEl = document.querySelector('[data-cart-subtotal]');
    const savingsRow = document.querySelector('.totals__savings');
    const savingsEl = document.querySelector('[data-cart-savings]');
    const totalEl = document.querySelector('[data-cart-total]');

    if (subtotalEl) {
      subtotalEl.textContent = formatMoney(
        cart.original_total_price
      );
    }

    if (savingsEl && savingsRow) {
      if (cart.total_discount > 0) {
        savingsRow.removeAttribute('hidden');
        savingsEl.textContent = `−${formatMoney(
          cart.total_discount
        )}`;
      } else {
        savingsRow.setAttribute('hidden', '');
      }
    }

    if (totalEl) {
      totalEl.textContent = formatMoney(
        cart.total_price
      );
    }
  };

  subscribe(PUB_SUB_EVENTS.cartUpdate, ({ cartData }) => {
    updateTotals(cartData);
  });
})();

(() => {
  const toggleUpsell = (cart) => {
    const upsell = document.querySelector('#CartUpsell');
    if (!upsell || !cart) return;

    let show = false;
    let grinderInCart = false;

    cart.items.forEach(item => {

      if (item.handle === upsell.dataset.grinderHandle) {
        grinderInCart = true;
      }

      const isSubscription = !!item.selling_plan_allocation;
      const grinderIncluded = item.variant_options?.includes('Grinder included'); // если прокидываешь через свойства

      if (!isSubscription && !grinderIncluded) {
        show = true;
      }
    });

    if (grinderInCart) show = false;

    upsell.style.display = show ? '' : 'none';
  };

  subscribe(PUB_SUB_EVENTS.cartUpdate, ({ cartData }) => {
    toggleUpsell(cartData);
  });
})();

document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-upsell-add]');
  if (!btn) return;

  const variantId = btn.dataset.variantId;
  if (!variantId) return;

  btn.classList.add('loading');
  btn.disabled = true;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: variantId,
      quantity: 1
    })
  })
  .then(() => {
    return fetch('/cart.js');
  })
  .then(r => r.json())
  .then((cart) => {
    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: 'cart-upsell',
      cartData: cart
    });
  })
  .finally(() => {
    btn.classList.remove('loading');
    btn.disabled = false;
  });
});

